export default __webpack_public_path__ + "static/media/grayCircle.78340dbb.svg";